
import { ITEM_STUB_MIME_TYPE } from './common/constants';
import MusicLibrary from './library/MusicLibrary.vue';
import { AudioPlayer } from './player';
import { LibraryItem, LibraryManager } from './library';
import { Settings } from './common/settings';
import PlaybackFooter from './PlaybackFooter.vue';
import { PlayQueues, QueueManager } from './queues';
import { defineComponent } from 'vue';
import { TreeActivateEvent } from './common/tree/tree-item';

export default defineComponent({
    components: {
        MusicLibrary,
        PlaybackFooter,
        PlayQueues,
    },
    props: {
        libraryManager: {
            type: LibraryManager,
            required: true,
        },
        queueManager: {
            type: QueueManager,
            required: true,
        },
        settings: {
            type: Settings,
            required: true,
        },
    },
    data() {
        const player = AudioPlayer.getOrCreateInstance(this.libraryManager);
        player.setQueue(this.queueManager.getActiveQueue());
        player.setVolume(this.settings.volume);
        player.setRepeatMode(this.settings.repeatMode);
        player.setShuffleMode(this.settings.shuffleMode);
        return {
            player,
            selectedItems: [] as Array<LibraryItem>,
        };
    },
    methods: {
        async activateItem(evt: TreeActivateEvent<LibraryItem>) {
            const tracksToAdd = await this.libraryManager.getChildTracks(
                evt.item.data
            );
            const newIndex = this.queueManager.activeQueue.size();
            this.queueManager.activeQueue.extend(tracksToAdd);
            const playNow = !evt.shiftKey && !evt.ctrlKey && !evt.altKey;
            if (playNow) {
                this.player.setQueue(this.queueManager.activeQueue);
                this.player.play(newIndex);
            }
            this.queueManager.saveQueues();
        },
        libraryDragStart(evt: DragEvent) {
            if (this.selectedItems.length > 0) {
                const textValues = this.selectedItems
                    .map((item) => `${item.type}: ${item.name}`)
                    .join('\n');
                evt.dataTransfer?.setData('text/plain', textValues);
                const jsonValues = this.selectedItems.map((item) => {
                    return {
                        type: item.type,
                        name: item.name,
                        id: item.id,
                    };
                });
                evt.dataTransfer?.setData(
                    ITEM_STUB_MIME_TYPE,
                    JSON.stringify(jsonValues)
                );
                const dragEl = this.$el.querySelector('.drag-counter');
                evt.dataTransfer?.setDragImage(dragEl, 10, dragEl.width / 2);
            } else {
                evt.preventDefault();
            }
        },
        updateSelection(selection: Array<LibraryItem>) {
            this.selectedItems = selection;
        },
    },
});
